import React, { useState } from 'react';
import { CreateSalesOrderRequest } from '../../types/sales.types';
import SalesOrderForm from '../forms/SalesOrderForm';
import { Modal } from '../ui/Modal';
import { Field, inputClass } from '../ui/FormControls';

interface CreateQuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CreateSalesOrderRequest) => Promise<void>;
  isLoading?: boolean;
}

const today = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

const CreateQuoteModal: React.FC<CreateQuoteModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading = false,
}) => {
  const [validUntil, setValidUntil] = useState('');

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => !isLoading && onClose()}
      title="Create New Quote"
      description="A quote does not reserve stock. Convert it to an order when the customer accepts."
      size="2xl"
      className="overflow-visible"
    >
      <div className="mb-5 max-w-xs">
        <Field label="Prices valid until" htmlFor="quote-valid-until" hint="Optional. Printed on the quotation.">
          <input id="quote-valid-until" type="date" min={today()} value={validUntil} onChange={(event) => setValidUntil(event.target.value)} className={inputClass} />
        </Field>
      </div>
      <SalesOrderForm
        onSubmit={(data) => onSubmit({ ...data, quoteValidUntil: validUntil || undefined })}
        onCancel={onClose}
        isLoading={isLoading}
        submitButtonText="Create Quote"
        mode="create"
        checkStock={false}
      />
    </Modal>
  );
};

export default CreateQuoteModal;
